import React from 'react';

import { useTranslation } from '@lt/localization';
import type { LuggageItem } from 'src/components/Luggage/types';
import styled from 'styled-components';
import { getLuggageText } from '../../../../../../../components/Luggage/luggageUtils';
import FlightsLuggageIconWithLabel from './FlightsLuggage/components/FlightsLuggageIconWithLabel';

const FlightsLuggageTooltip = ({
  luggage,
  hasTitle,
}: {
  luggage: LuggageItem[];
  hasTitle: boolean;
}): JSX.Element => {
  const { t } = useTranslation();

  return (
    <StyledContainer>
      {hasTitle && (
        <StyledTitle>{t('checkout.flight.luggage.summary')}:</StyledTitle>
      )}

      <div />

      <div>
        {luggage.map(([type, luggageParams]) => (
          <StyledLuggageItem key={type}>
            <FlightsLuggageIconWithLabel
              key={type}
              weight={luggageParams.weight}
              count={luggageParams.count}
              type={type}
            />
            {getLuggageText(luggageParams, type)}
          </StyledLuggageItem>
        ))}
      </div>
    </StyledContainer>
  );
};

const StyledTitle = styled.h4`
  font-size: 14px;
  padding: 0 10px;
`;

const StyledContainer = styled.div`
  color: #4d4d4d;
`;

const StyledLuggageItem = styled.div`
  font-size: 14px;
  line-height: 16px;
  margin-top: 10px;
  display: flex;
  align-items: center;
  text-align: left;

  > :first-child {
    margin-right: 6px;
  }
`;
export default FlightsLuggageTooltip;
